export const bannerCareers = {
  title: "CAREERS",
  subtitle: "Want to join our teams?",
  buttonJob: "View our job openings",
  buttonSendResume: "Send resume",
};
